import React, { FC, useContext } from 'react'
import { Helmet } from 'react-helmet'
import { PlusIcon } from '@heroicons/react/outline'
import ROUTES from '../utils/routes'
import { userStore } from '../utils/UserContext'
import {
  StyledDashboard, Captions, Photos, Community, DashboardTile, DraftsTile
} from '.'
import { ChallengeOptIn } from '../ChallengeOptIn'
import { WidthController } from '../Grid'
import { DailyAction } from '../DailyAction'
import useDraft from '../../redux/draft-drawer/useDraft'
import useSegment from '../utils/useSegment'
import { SplitContext } from '../utils/SplitContext'

const Dashboard: FC = () => {
  const { user } = useContext(userStore)
  const { track } = useSegment()
  const { actions: { openDraft } } = useDraft()
  const {
    isReady,
    isEnabled,
    treatments: { dashboardCaptions, dashboardPhotos }
  } = useContext(SplitContext)

  const showCaptions = isReady && isEnabled(dashboardCaptions)
  const showPhotos = isReady && isEnabled(dashboardPhotos)

  const getGreeting = () => {
    const now = new Date().getHours()

    if (now < 12) {
      return 'Good morning'
    }

    if (now < 18) {
      return 'Good afternoon'
    }

    return 'Good evening'
  }

  const openDraftDrawer = () => {
    track('Opened Draft Drawer', { button: 'dashboard-heading', from: window.location.pathname })
    openDraft()
  }

  return (
    <StyledDashboard>
      <Helmet
        title={`${getGreeting()}, ${
          user?.displayName ? user?.displayName.split(' ')[0] : user?.displayName
        }`}
      />

      <div className="dashboard-header-container">
        <WidthController noHeight noPadding>
          <div className="dashboard-header">
            <div>
              <h2>{getGreeting()}</h2>
              <h1>{user?.displayName}</h1>
            </div>
            <button className="new-post-btn" onClick={() => openDraftDrawer()}>
              <span>New Post</span> <PlusIcon />
            </button>
          </div>
        </WidthController>
      </div>

      <WidthController noHeight noPadding>
        <DailyAction />

        <ChallengeOptIn />

        <DashboardTile title="Recent Drafts" url={{ path: ROUTES.dashboard.drafts }}>
          <DraftsTile />
        </DashboardTile>

        <DashboardTile
          title="Events in the Community"
          url={{ path: ROUTES.external.communityEventsUrl, external: true }}
        >
          <Community />
        </DashboardTile>

        {showPhotos && (
          <DashboardTile title="Photos For You" url={{ path: ROUTES.gallery.main }}>
            <Photos />
          </DashboardTile>
        )}

        {showCaptions && (
          <DashboardTile title="Captions For You" url={{ path: ROUTES.captions }}>
            <Captions />
          </DashboardTile>
        )}
      </WidthController>
    </StyledDashboard>
  )
}

export default Dashboard
